// Lightweight, dependency-free helper around PostHog `capture()`.
// Fails silently if PostHog is not available (script blocked, ad blocker,
// no consent yet). Never sends article text, subscriber identifiers, IPs,
// email addresses, or secret credentials.

const isSafe = (v) => v === null || v === undefined || ["string", "number", "boolean"].includes(typeof v);

export const captureAudioEvent = (event, properties = {}) => {
  if (typeof window === "undefined") return;
  try {
    if (window.posthog && typeof window.posthog.capture === "function") {
      const clean = {};
      Object.entries(properties || {}).forEach(([k, v]) => {
        if (isSafe(v)) clean[k] = v;
      });
      window.posthog.capture(event, clean);
    }
  } catch {
    /* no-op: analytics failures must never affect playback */
  }
};

// Fires only once per component mount. Callers pass a ref-backed `firedRef`
// to guarantee the "reading_time_displayed" event is not double-counted
// during React strict-mode double-invocation or on re-render.
export const captureReadingTimeOnce = (firedRef, properties = {}) => {
  if (!firedRef || firedRef.current) return;
  firedRef.current = true;
  captureAudioEvent("reading_time_displayed", properties);
};
